import { render, staticRenderFns } from "./PB-Stepper.vue?vue&type=template&id=1409e04a&scoped=true&"
import script from "./PB-Stepper.vue?vue&type=script&lang=js&"
export * from "./PB-Stepper.vue?vue&type=script&lang=js&"
import style0 from "./PB-Stepper.vue?vue&type=style&index=0&id=1409e04a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1409e04a",
  null
  
)

export default component.exports